import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgArrowSquareOut = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 11.375a.875.875 0 1 1-1.75 0V6.488l-7.255 7.256a.876.876 0 0 1-1.238-1.238l7.255-7.256h-4.887a.875.875 0 1 1 0-1.75h7a.875.875 0 0 1 .875.875v7ZM20.125 14a.875.875 0 0 0-.875.875v7.875h-14v-14h7.875a.875.875 0 1 0 0-1.75H5.25A1.75 1.75 0 0 0 3.5 8.75v14a1.75 1.75 0 0 0 1.75 1.75h14A1.75 1.75 0 0 0 21 22.75v-7.875a.875.875 0 0 0-.875-.875Z" />
  </svg>
);
export default SvgArrowSquareOut;
